module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Product"
  }, [_c('div', {
    staticClass: "Product-Image"
  }, [_c('images', {
    attrs: {
      "images": _vm.product.image,
      "titleNext": _vm.$t('product.title_slider_next'),
      "titlePrevious": _vm.$t('product.title_slider_previous')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Product-Details"
  }, [_c('buy-box', {
    attrs: {
      "is_active": (_vm.cart.length > 0) ? true : false
    }
  }), _vm._v(" "), _c('Cart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cart.length > 0),
      expression: "cart.length > 0"
    }],
    attrs: {
      "can_remove": true,
      "display_coupon": false
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ecaf5d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/product-details.vue
// module id = 258
// module chunks = 1